<div class="home-bg" id="home">
  <div class="row align-items-center justify-content-center">
    <div class="col-lg-6 col-md-7">
      <div class="home-text">
        <h2>SOS - Shining On Safety <br> <span>Safety</span>University</h2>
        <h6>Start learning right away and earn your certificate</h6>
        <br>
        <div class="docutment-button" [routerLink]="['/register']">
          <a class="btn bg-primary">
            <svg>
              <use href="../assets/svg/icon-sprite.svg#fill-layout"></use>
            </svg>Sign Up !</a>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-5">
      <div class="home-screen">
        <div class="screen-1"><img class="img-fluid" src="assets/landing/home/1.jpeg" alt=""></div>
        <div class="screen-2"><img class="img-fluid" src="assets/landing/home/2.jpeg" alt=""></div>
        <div class="screen-3"><img class="img-fluid" src="assets/landing/home/3.jpg" alt=""></div>
      </div>
    </div>
  </div>
</div>